import { render } from "./ContentPacksView.vue?vue&type=template&id=495ae7b5&scoped=true"
import script from "./ContentPacksView.vue?vue&type=script&lang=js"
export * from "./ContentPacksView.vue?vue&type=script&lang=js"

import "./ContentPacksView.vue?vue&type=style&index=0&id=495ae7b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495ae7b5"]])

export default __exports__